import getRequest from '@/client/utils/getRequest'
import { basePath } from '@/next.config'
import filterTracksWithSameMix from '@/utils/music/filterTracksWithSameMix'

export const clientGetSimilarTracks = async (
	trackIds: number[]
): Promise<Track[] | []> => {
	const tracks = await getRequest<Track[]>(
		`${basePath}/api/musicapp/aims/similar?trackIds=${trackIds}&include=royaltysplits`,
		'aims similar tracks'
	)

	if (!tracks) {
		return []
	}

	return filterTracksWithSameMix(tracks)
}
